export const ALERT_DEFINITIONS = {
  WRONG_NETWORK: {
    id: "wrong_network",
    title: "Assets Found on a Different Network",
    type: "visibility",
    risk: "low",
    urgency: "none",
    message:
      "Some assets exist on a blockchain different from the one your wallet is currently viewing.",
    reassurance:
      "This is a common visibility issue and does not mean your assets are lost.",
  },

  MISSING_TOKENS: {
    id: "missing_tokens",
    title: "Some Tokens Are Not Visible in Your Wallet",
    type: "visibility",
    risk: "none",
    urgency: "none",
    message:
      "One or more tokens exist in your wallet but are not currently shown by your wallet app.",
    reassurance:
      "This is normal and often related to wallet display or spam filtering settings.",
  },

  STUCK_TRANSACTION: {
    id: "stuck_transaction",
    title: "Pending Transaction Blocking Wallet Activity",
    type: "transaction",
    risk: "medium",
    urgency: "high",
    message:
      "A transaction has been pending for an extended period and may be blocking new activity.",
    reassurance:
      "This is usually resolvable and does not indicate lost funds.",
  },
};
